/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React, {FC} from 'react';
import getConfig from 'next/config';
import Link from 'next/link';
import {format} from 'url';

const {publicRuntimeConfig} = getConfig();

type Props = {
  children: React.ReactNode;
  href: string;
};

/**
 * The AppLink provides a wrapper component around the Next/Link which allows
 * for customizing all Links within an iOn Application.
 *
 * ```typescript
 *
 *   <AppLink href='some/page'>
 *     {t('namespace:some.key')}
 *   </AppLink>
 *
 * ```
 */
export const AppLink: FC<Props> = ({children, ...props}: Props) => {
  const path = `${publicRuntimeConfig.basePath || ''}${format(props.href)}`;
  return (
    <Link {...props} href={props.href} as={path}>
      {children}
    </Link>
  );
};
export default AppLink;
